/* global WP_API_Settings, REST_API, alert, wp */
import Mojito from '../../../bower_components/mojito/lib/main';

export default class AttendendsController extends Mojito.Controller {


    constructor(...args) {
        super(args);
        this.user = args[0];

    }

    printMember(value) {
        let style = '--';
        let cla = '';

        switch (value) {
            case 1:
                style = 'Ja';
                cla = 'is--yes';
                break;
            case 2:
                style = 'Nein';
                cla = 'is--no';
                break;
            case 3:
                style = 'Vielleicht';
                cla = 'is--maybe';
                break;
            default:
                style = '--';
        }

        this.$().find('div[data-id="' + this.user.id + '"] + div').attr('data-value', value).html(style).removeClass('is--yess').removeClass('is--no').removeClass('is--maybe').addClass(cla);
        this.$().find('div[data-id="' + this.user.id + '"]').removeClass('is--yess').removeClass('is--no').removeClass('is--maybe').addClass(cla);
    }

    valueObserver() {
        return Mojito.observer('value', () => {

            let value = parseInt(this.get('value'));

            if(value === 0) {
                return;
            }

            let data = {
                POSTID: this.user.event,
                USERID: this.user.id,
                STATE: value,
                FNAME: this.user.fname,
                LNAME: this.user.lname,
                MAIL: this.user.user
            };
            console.log(document.location.origin + '/eventparticipate/');

            $.ajax({
                method: 'POST',
                data: data,
                url: document.location.origin + '/eventparticipate/',
                success : ( response )  => {
                    console.log( response );
                    this.printMember(value);
                },
                fail : ( response )  => {
                    console.log( response );
                },
                statusCode: {
                    401:function() { alert('401 Nicht Authorisiert für eine Teilnahme!'); },
                    404:function() { alert('404 Event nicht gefunden'); }
                }
            });
        });
    }
}
